<script lang="ts" setup>
import ReadmoreBlock from 'theme/components/molecules/ReadmoreBlock.vue';
import { useDeviceType } from 'theme/composables/useDeviceType';

const { isDesktop } = useDeviceType();

const props = withDefaults(
  defineProps<{
    type: number;
  }>(),
  { type: 1 }
);

const title = ref('');
const subtitle = ref('');
const description = ref('');

switch (props.type) {
  case 1:
    title.value = '宣言1';
    subtitle.value = '家計・家族構成などを軸にした\n最適なご提案を行います';
    description.value =
      'オカネコのオンラインアドバイザー（当社社員）は、オカネコの家計診断で得た家計等に関する定量的なデータと、お金の悩みなどについての定性的なデータを踏まえ、ユーザーの皆さま一人ひとりの状況やお悩みにあわせ最適なご提案を行うよう努めます。';
    break;
  case 2:
    title.value = '宣言2';
    subtitle.value = '公助・共助・自助の原則を踏まえた\nご提案を行います';
    description.value =
      'オカネコのオンラインアドバイザーは、公的保険アドバイザーの資格を取得し、本来あるべき公助・共助・自助の順番で保障されている内容を確認の上、金融アドバイスを提供します。\n有価証券分野においても、ユーザーの皆さまの資産運用の目的を明確化し、必要とする金額やそのために行うべき運用の方法をアドバイスします。';
    break;
  case 3:
    title.value = '宣言3';
    subtitle.value = '負担する費用等の\n丁寧な説明をいたします';
    description.value =
      'オカネコのオンラインアドバイザーがユーザーの皆さまに販売した金融商品や保険商品は、委託元の証券会社や保険会社から手数料等を受領しています。そのため、ユーザーの皆さまが負担する費用について丁寧に説明します。';
    break;
  case 4:
    title.value = '宣言4';
    subtitle.value =
      'テクノロジーを活用した\n利便性の高いお金の相談体験を\nご提供します';
    description.value =
      'オカネコは仕事や子育て等で忙しい方や、対面での相談に抵抗がある方でもご利用いただきやすいよう、オンラインで簡単にお金に関する相談ができるサービスです。また、情報セキュリティの強化・個人情報の適切な取り扱いにも務めており、その一環としてISMS認証及びPマークを取得しています。\n今後も安心安全な情報管理体制の下、テクノロジーの力を活用することで誰でも利便性高くお金の相談をできるようなサービスを追求していきます。';
    break;
  case 5:
    title.value = '宣言5';
    subtitle.value = '契約後の丁寧な\nアフターフォローを行います';
    description.value =
      'オカネコのオンラインアドバイザーは、ご契約後もユーザーの皆さまへ定期的な情報提供やライフプランの見直しなどを行います。\n特にお金の領域における悩みは、ユーザーの皆さまの家族状況や仕事内容に応じて変化していくものです。オカネコは恒常的に信頼されるアドバイザーであるよう丁寧なアフターフォローを心がけます。';
    break;
  case 6:
    title.value = '宣言6';
    subtitle.value = '顧客利益を最優先するための\n組織体制を目指します';
    description.value =
      'オカネコはユーザーの皆さまのお金の問題を出会いで解決するための仕組みが提供できるようなチームづくりやガバナンス体制の整備に取り組んでまいります。';
    break;
  default:
    break;
}

const style = useCssModule();
const innerClassNames = computed(() => [
  style.inner,
  style[`inner--${props.type}`],
]);

const titleClassNames = computed(() => [
  style.title,
  style[`title--${props.type}`],
]);

const hrClassNames = computed(() => [style.hr, style[`hr--${props.type}`]]);
</script>

<template>
  <div :class="$style.outer">
    <div :class="innerClassNames">
      <h2 :class="titleClassNames">{{ title }}</h2>
      <img
        v-if="props.type == 1"
        :class="$style.image"
        src="./image1.svg"
        alt="宣言1"
      />
      <img
        v-else-if="props.type == 2"
        :class="$style.image"
        src="./image2.svg"
        alt="宣言2"
      />
      <img
        v-else-if="props.type == 3"
        :class="$style.image"
        src="./image3.svg"
        alt="宣言3"
      />
      <img
        v-else-if="props.type == 4"
        :class="$style.image"
        src="./image4.svg"
        alt="宣言4"
      />
      <img
        v-else-if="props.type == 5"
        :class="$style.image"
        src="./image5.svg"
        alt="宣言5"
      />
      <img
        v-else-if="props.type == 6"
        :class="$style.image"
        src="./image6.svg"
        alt="宣言6"
      />
      <div :class="$style.subtitle">
        <h3 :class="$style.subtitle__text">{{ subtitle }}</h3>
      </div>
      <div :class="hrClassNames" />
      <p v-if="isDesktop" :class="$style.description">{{ description }}</p>
      <ReadmoreBlock v-else :collapse-lines="3">
        <p :class="$style.description">{{ description }}</p>
      </ReadmoreBlock>
    </div>
    <div :class="[$style['quote-wrapper'], $style['quote-wrapper--start']]">
      <img
        v-if="props.type == 1"
        :class="[$style.quote, $style['quote--start']]"
        src="./quote_blue_start.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 2"
        :class="[$style.quote, $style['quote--start']]"
        src="./quote_orange_start.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 3"
        :class="[$style.quote, $style['quote--start']]"
        src="./quote_purple_start.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 4"
        :class="[$style.quote, $style['quote--start']]"
        src="./quote_yellow_start.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 5"
        :class="[$style.quote, $style['quote--start']]"
        src="./quote_red_start.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 6"
        :class="[$style.quote, $style['quote--start']]"
        src="./quote_green_start.svg"
        alt="”"
      />
    </div>
    <div :class="[$style['quote-wrapper'], $style['quote-wrapper--end']]">
      <img
        v-if="props.type == 1"
        :class="[$style.quote, $style['quote--end']]"
        src="./quote_blue_end.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 2"
        :class="[$style.quote, $style['quote--end']]"
        src="./quote_orange_end.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 3"
        :class="[$style.quote, $style['quote--end']]"
        src="./quote_purple_end.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 4"
        :class="[$style.quote, $style['quote--end']]"
        src="./quote_yellow_end.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 5"
        :class="[$style.quote, $style['quote--end']]"
        src="./quote_red_end.svg"
        alt="”"
      />
      <img
        v-else-if="props.type == 6"
        :class="[$style.quote, $style['quote--end']]"
        src="./quote_green_end.svg"
        alt="”"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.outer {
  width: 360px;
  position: relative;
  display: flex;
  align-items: center;

  @include desktop-only {
    height: 736px;
  }
}

.quote-wrapper {
  width: calc(47px + 16px);
  height: calc(40px + 16px);
  position: absolute;
  background-color: $color-white-1000;

  &--start {
    top: 0;
    left: 0;
  }

  &--end {
    bottom: 0;
    right: 0;
  }
}

.quote {
  width: 47px;
  height: 40px;
  position: absolute;

  &--start {
    top: 0;
    left: 0;
  }

  &--end {
    bottom: 0;
    right: 0;
  }
}

.inner {
  margin: 20px 10px;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include desktop-only {
    height: calc(100% - 20px);
  }

  &--1 {
    border: 12px solid $color-blue-200;
  }

  &--2 {
    border: 12px solid $color-orange-200;
  }

  &--3 {
    border: 12px solid $color-purple-200;
  }

  &--4 {
    border: 12px solid $color-yellow-200;
  }

  &--5 {
    border: 12px solid $color-red-200;
  }

  &--6 {
    border: 12px solid $color-green-300;
  }
}

.title {
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 10px;

  &--1 {
    color: $color-blue-800;
  }

  &--2 {
    color: $color-orange-700;
  }

  &--3 {
    color: $color-purple-800;
  }

  &--4 {
    color: $color-yellow-600;
  }

  &--5 {
    color: $color-red-800;
  }

  &--6 {
    color: $color-teal-700;
  }
}

.image {
  margin-top: 10px;
}

.subtitle {
  display: table;
  height: 90px;
  margin-top: 20px;

  &__text {
    display: table-cell;
    font-size: 18px;
    font-weight: bold;
    line-height: 165%;
    text-align: center;
    vertical-align: middle;
    white-space: pre-wrap;
  }
}

.hr {
  width: 100%;
  height: 4px;
  margin: 24px 0;

  &--1 {
    background-color: $color-blue-200;
  }

  &--2 {
    background-color: $color-orange-200;
  }

  &--3 {
    background-color: $color-purple-200;
  }

  &--4 {
    background-color: $color-yellow-200;
  }

  &--5 {
    background-color: $color-red-200;
  }

  &--6 {
    background-color: $color-green-300;
  }
}

.description {
  font-size: 14px;
  font-weight: 400;
  line-height: 180%;
  white-space: pre-wrap;
}
</style>
